import Keycloak from 'keycloak-js';

// Configuración de Keycloak usando la instancia existente de tu empresa
const keycloakConfig = {
  url: 'https://iam.ia.blend360.com', // URL base del servidor Keycloak de tu empresa
  realm: 'master',                  // Nombre del realm configurado en Keycloak
  clientId: 'abstract-reasoning-admin',
};

// Inicializar Keycloak
const keycloak = new Keycloak(keycloakConfig);

export default keycloak; 